import Hero from "@/components/sections/Hero";
import ProblemAudit from "@/components/sections/ProblemAudit";
import WhyDotapan from "@/components/sections/WhyDotapan";
import Story from "@/components/sections/Story";
import Categories from "@/components/sections/Categories";
import PizzaFeature from "@/components/sections/PizzaFeature";
import ProductCarousel from "@/components/sections/ProductCarousel";
import HorecaBenefits from "@/components/sections/HorecaBenefits";
import Process from "@/components/sections/Process";
import Safety from "@/components/sections/Safety";
import Packaging from "@/components/sections/Packaging";
import Testimonials from "@/components/sections/Testimonials";
import FAQ from "@/components/sections/FAQ";
import FinalCTA from "@/components/sections/FinalCTA";

export default function Home() {
  return (
    <div data-testid="page-home" className="-mt-16 md:-mt-20">
      <Hero />
      <ProblemAudit />
      <WhyDotapan />
      <Story />
      <Categories />
      <PizzaFeature />
      <ProductCarousel />
      <HorecaBenefits />
      <Process />
      <Safety />
      <Packaging />
      <Testimonials />
      <FAQ />
      <FinalCTA />
    </div>
  );
}
